import {ImportingDataTypes} from "../../types";
import {createInvalidPartSection, PreventionInvalidityCode} from "./shared";

export const preventativeInteraction = {
    datasourceId: ImportingDataTypes.partUPC,
    sections: [
        createInvalidPartSection(),
        {
            sectionKey: 'missingUPC',
            sectionTitle: 'Missing UPC Code',
            invalidityCode: PreventionInvalidityCode.MISSING_REQUIRED_FIELDS,
            fields: [
                {
                    key: 'partNumber',
                    label: 'Part Number',
                    type: 'text',
                    extractValue: (o) => typeof o === 'string' ? o : o?.partNo ?? null, // partNo is explicitly used since autocomplete provides partNo field
                    modifyRow: (row, val) => ({...row, partNumber: val})
                },
                {
                    key: 'upc',
                    label: 'UPCs',
                    type: 'input',
                    modifyRow: (row, val) => ({...row, upc: val})
                }
            ]
        }
    ],
};
